export var CfgMtrlApplicationSource;
(function (CfgMtrlApplicationSource) {
    CfgMtrlApplicationSource["ApplicationArea"] = "ApplicationArea";
    CfgMtrlApplicationSource["Product"] = "Product";
    CfgMtrlApplicationSource["Feature"] = "Feature";
    CfgMtrlApplicationSource["Option"] = "Option";
    CfgMtrlApplicationSource["Debug"] = "Debug";
})(CfgMtrlApplicationSource || (CfgMtrlApplicationSource = {}));
